import { MissionToStaffExpenses } from '../../lib/types/models/mission-to-staff/mission-to-staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function getMissionToStaff(missionToStaffId: number) {
  return restApiClient
    .url(constructApiUrl(API.missionToStaffs.getMissionToStaff.url, { id: missionToStaffId }))
    .get<MissionToStaffExpenses>()
}
